import type { Types as OData } from 'shared/odata'

import type { State } from './types'

const statusToCN = {
	Completed: 'completed',
	Compose: 'drafted',
	Running: 'active',
	Stopped: 'paused'
} as const satisfies Record<State, string>

const statusToColor = {
	Completed: 'var(--status-completed)',
	Compose: 'var(--light-grey)',
	Running: '#04c300',
	Stopped: 'var(--status-paused)'
} as const satisfies Record<State, string>

const RECENT_PARAMS: Partial<OData.Page> = {
	$orderby: 'created desc',
	$take: 5
}
export { RECENT_PARAMS, statusToCN, statusToColor }
